/**
 * The prompt out of the guide's wiki page: the guide opens with a heading and
 * a paragraph about itself, then a rule (`---`), then the prompt proper. An
 * agent gets the part after the rule; a page without one is copied whole.
 */
export function promptFromGuide(body: string): string {
  const match = body.match(/^\s*---\s*$/m);
  const text =
    match && match.index !== undefined
      ? body.slice(match.index + match[0].length)
      : body;
  return text.trim();
}
